import { SvgIcon } from 'ui/icons/SvgIcon';

export const IterableEmail = ({ height = 48, width = 48 }) => (
  <SvgIcon height={height} width={width} viewBox="0 0 64 64">
    <g clipPath="url(#iterable_email_svg_bg)">
      <path
        opacity="0.25"
        d="M45.0678 27.713L27.9526 44.8281L36.5746 53.4501L53.6897 36.3349L45.0678 27.713Z"
        fill="#59C1A7"
      />
      <path
        opacity="0.25"
        d="M36.4603 10.4562L27.8384 19.0781L44.9535 36.1933L53.5755 27.5714L36.4603 10.4562Z"
        fill="#34C3F2"
      />
      <path
        opacity="0.15"
        d="M19.0804 27.7218L10.4585 36.3438L27.5737 53.4589L36.1956 44.837L19.0804 27.7218Z"
        fill="#EF3D55"
      />
      <path
        opacity="0.15"
        d="M27.9824 10.0513L10.8672 27.1665L19.4891 35.7884L36.6043 18.6733L27.9824 10.0513Z"
        fill="#6A266D"
      />
      <path
        d="M32.0455 20.779C35.4377 20.779 38.1877 18.029 38.1877 14.6368C38.1877 11.2446 35.4377 8.49463 32.0455 8.49463C28.6533 8.49463 25.9033 11.2446 25.9033 14.6368C25.9033 18.029 28.6533 20.779 32.0455 20.779Z"
        fill="#6A266D"
      />
      <path
        d="M49.3805 38.1906C52.7727 38.1906 55.5226 35.4407 55.5226 32.0484C55.5226 28.6562 52.7727 25.9062 49.3805 25.9062C45.9882 25.9062 43.2383 28.6562 43.2383 32.0484C43.2383 35.4407 45.9882 38.1906 49.3805 38.1906Z"
        fill="#34C3F2"
      />
      <path
        d="M32.0455 55.5236C35.4377 55.5236 38.1877 52.7737 38.1877 49.3814C38.1877 45.9892 35.4377 43.2393 32.0455 43.2393C28.6533 43.2393 25.9033 45.9892 25.9033 49.3814C25.9033 52.7737 28.6533 55.5236 32.0455 55.5236Z"
        fill="#59C1A7"
      />
      <path
        d="M14.711 38.1227C18.1033 38.1227 20.8532 35.3728 20.8532 31.9806C20.8532 28.5883 18.1033 25.8384 14.711 25.8384C11.3188 25.8384 8.56885 28.5883 8.56885 31.9806C8.56885 35.3728 11.3188 38.1227 14.711 38.1227Z"
        fill="#EF3D55"
      />
    </g>
    <path
      d="M41.8153 43.3884L51 51.6546L60.1847 43.3885C59.8531 43.1443 59.4434 43 59 43H43C42.5566 43 42.1469 43.1443 41.8153 43.3884Z"
      fill="#79347F"
    />
    <path
      d="M61 45.3454L52.3379 53.1412C51.5773 53.8258 50.4227 53.8258 49.6621 53.1412L41 45.3454V57C41 58.1046 41.8954 59 43 59H59C60.1046 59 61 58.1046 61 57V45.3454Z"
      fill="#79347F"
    />
    <defs>
      <clipPath id="iterable_email_svg_bg">
        <rect width="48" height="48" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
